import api from './api'

const settingsService = {
  async get() {
    const response = await api.get('/settings')
    return response.data
  },

  async update(payload) {
    const response = await api.post('/settings', payload)
    return response.data
  }
}

export default settingsService


